import { useEffect, useState } from "react";
import { auth } from "../utils/firebase";

const useAuthUser = () => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((u) => setUser(u));
    return () => unsubscribe();
  }, []);
  return user;
};

export default useAuthUser;
